import React, { useState } from "react";
import {
  Outlet,
  useLocation,
  useNavigate
} from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";

import { useAuth } from "../../context/AuthContext";

const DashboardLayout = ({
  user = null,
  onLogout
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { user: authUser, logout } = useAuth();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  /*
  |--------------------------------------------------------------------------
  | USER
  |--------------------------------------------------------------------------
  |
  | Prefer the user coming from AuthContext.
  | The prop is kept for compatibility with the existing layout.
  |
  */

  const currentUser = user || authUser;

  /*
  |--------------------------------------------------------------------------
  | NAVIGATION
  |--------------------------------------------------------------------------
  */

  const handleNavigation = (path) => {
    navigate(path);
    setSidebarOpen(false);
  };

  /*
  |--------------------------------------------------------------------------
  | LOGOUT
  |--------------------------------------------------------------------------
  */

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
      return;
    }

    logout();

    setSidebarOpen(false);

    navigate("/login", {
      replace: true
    });
  };

  return (
    <div className="dashboard-layout">

      {/* SIDEBAR */}
      <Sidebar
        user={currentUser}
        currentPath={location.pathname}
        onNavigate={handleNavigation}
        onLogout={handleLogout}
        mobileOpen={sidebarOpen}
        onClose={() =>
          setSidebarOpen(false)
        }
      />

      {/* MAIN */}
      <div className="dashboard-main">

        {/* HEADER */}
        <Header
          user={currentUser}
          onMenuClick={() =>
            setSidebarOpen(true)
          }
          onProfileClick={() =>
            navigate("/dashboard/profile")
          }
          onLogout={handleLogout}
        />

        {/* PAGE CONTENT */}
        <main className="dashboard-content">
          <Outlet />
        </main>

      </div>
    </div>
  );
};

export default DashboardLayout;